export const stateAttributesMapping = {
  inputValue: () => null,
  value: () => null
};